export default "__VITE_ASSET__CgEuGd5q__"